import { collection } from "firebase/firestore";
import { db } from "../firebaseConfig";


export const getSubCollection = (uid, subcol) =>
  collection(db, "usuarios", uid, subcol);